import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

import DstButton from "../../../components/DstButton/DstButton";
import DstTable from "../../../components/DstTable/DstTable";
import { useSession } from "../../../contexts/SessionContext";
import translate from "../../../services/Translate";
import { fetchLeadersWorkload } from "./CohortLeadersWorkload.function";

const CohortLeadersWorkload = () => {
  const { language } = useSession();
  const [workload, setWorkload] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [onlyActive, setOnlyActive] = useState(true);

  useEffect(() => {
    fetchLeadersWorkload(setWorkload, setLoading, onlyActive, language);
  }, [language, onlyActive]);

  const columns = [
    {
      key: "index",
      name: "#",
    },
    {
      key: "user.full_name",
      name: translate(language, "PAGES.COHORTS_WORKLOAD.COLUMNS.NAME"),
      render: (item: any) => (
        <a href={`/user/${item.user.id}`} className="text-decoration-underline">
          {item.user.full_name}
        </a>
      ),
    },
    {
      key: "user.email",
      name: translate(language, "PAGES.COHORTS_WORKLOAD.COLUMNS.EMAIL"),
    },
    {
      key: "count",
      name: translate(language, "PAGES.COHORTS_WORKLOAD.COLUMNS.COUNT"),
    },
    {
      key: "load",
      name: translate(language, "PAGES.COHORTS_WORKLOAD.COLUMNS.LOAD"),
    },
  ];

  return (
    <div className="cohorts-container m-5">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-md-5">
        <div className="d-flex w-fit align-items-center justify-content-between">
          <h2 className="mb-0 me-3">{translate(language, "PAGES.COHORTS_WORKLOAD.TITLE_LEADER")}</h2>
        </div>
        <div className="d-flex flex-wrap gap-2">
          <div className="me-2 d-flex align-items-center">
            <DstButton
              btnClass="h-100 d-flex align-items-center"
              btnImageBefore={
                <Form.Check
                  type="switch"
                  className="check-box s-bold me-2"
                  checked={onlyActive}
                  onChange={() => setOnlyActive(!onlyActive)}
                />
              }
              value={translate(language, "PAGES.COHORTS_WORKLOAD.ONLY_ACTIVE")}
              variant="light"
              btnHeight="50px"
              btnWidth="150px"
              mock={!workload}
              clickFunction={() => setOnlyActive(!onlyActive)}
            />
          </div>
        </div>
      </div>
      <DstTable columns={columns} data={workload} loading={loading} striped />
    </div>
  );
};

export default CohortLeadersWorkload;
